import moment from 'moment';
import immutableUpdate from 'react-addons-update';
import * as _ from '../lodash';
import {
  SET_FRAMES,
  SET_FRAMES_FRAMES,
  SET_GOT_PAGE,
  SET_BLACKOUTS,
  SET_TIME_SLOTS,
  SET_AVAILABLE_BLOCKS,
  FETCH_TIME_SLOT_LOADING,
  SET_EXTERNAL_ID_SELECTED,
  SET_NON_AVAILABLE_BLOCKS,
  SET_CURRENT_MONTH,
} from '../actions/frames';

/**
 * get blackouts from timeslots
 * Blackouts has status euqals to 2
 * @param {array} timeslots array of timeslots
 */
function getBlackouts(blocks) {
  return blocks.length > 0 ? blocks.filter(timeslot => timeslot.timeslots[0].status === 2) : [];
}

/**
 * get availables blocks from blocks array.
 * @param {array} blocks array of blocks
 */
function getAvailableBlocks(blocks) {
  return blocks.length > 0 ? blocks.filter(timeslot => timeslot.timeslots[0].status === 1) : [];
}

/**
 * Returns all dates in a month by specified a year and a month.
 * @param {Date} year Year
 * @param {Date} month Month
 */
function getDaysArray(year, month) {
  const date = new Date(year, month, 1);
  const days = [];
  while (date.getMonth() === month) {
    days.push(new Date(date));
    date.setDate(date.getDate() + 1);
  }
  return days;
}

const initialState = {
  data: [],
  frames: [],
  blackouts: [],
  timeslots: [],
  cachedParams: [],
  externalId: null,
  nextOccurrence: '',
  availableBlocks: [],
  flattenTimeSlots: [],
  nonAvailableBlocks: [],
  isFetchingBlocks: false,
  lastOccurrence: new Date(),
  currentMonth: moment().toDate(),
};

export default function framesReducer(state = initialState, action) {
  switch (action.type) {
    case SET_GOT_PAGE: {
      const temp = state.cachedParams;
      temp.push(action.value);
      return immutableUpdate(state, {
        cachedParams: { $set: temp },
      });
    }

    case SET_FRAMES: {
      const {
        frames, lastOccurrence, nextOccurrence, flattenTimeSlots
      } = action.value;

      if (!frames) return state;

      frames.forEach((x) => {
        const frame = _.find(state.frames, y => y.date === x.date);
        if (frame) {
          x.timeslots.forEach((timeslot) => {
            const slot = _.find(frame.timeslots, slot => {
              return slot.start === timeslot.start &&
                slot.finish === timeslot.finish &&
                slot.location_id === timeslot.location_id
            });
            if (!slot) frame.timeslots.push(timeslot);
          })
        } else {
          state.frames.push({...x});
        }
      });

      return immutableUpdate(state, {
        frames: { $set: state.frames },
        flattenTimeSlots: { $set: flattenTimeSlots },
        nextOccurrence: { $set: nextOccurrence },
        lastOccurrence: { $set: lastOccurrence ? lastOccurrence : state.lastOccurrence },
      });
    }

    case SET_FRAMES_FRAMES: {
      return immutableUpdate(state, {
        frames: { $set: action.frames },
      });
    }

    case SET_TIME_SLOTS: {
      return immutableUpdate(state, {
        timeslots: { $set: action.value || [] },
      });
    }

    case SET_EXTERNAL_ID_SELECTED: {
      return immutableUpdate(state, {
        externalId: { $set: action.value },
      });
    }

    case SET_BLACKOUTS: {
      return immutableUpdate(state, {
        blackouts: { $set: getBlackouts(action.value) },
      });
    }

    case SET_AVAILABLE_BLOCKS: {
      return immutableUpdate(state, {
        availableBlocks: { $set: getAvailableBlocks(action.value) },
      });
    }

    case SET_NON_AVAILABLE_BLOCKS: {
      const daysInMonth = action.value[5] ? getDaysArray(moment(action.value[5].date).year(), moment(action.value[5].date).month()) : [];
      const blocksDates = action.value.map(el => moment(el.date).toDate().getTime());
      const nonBlocks = daysInMonth.filter(day => !blocksDates.includes(day.getTime()));
      return immutableUpdate(state, {
        nonAvailableBlocks: { $set: nonBlocks },
      });
    }

    case FETCH_TIME_SLOT_LOADING: {
      return immutableUpdate(state, {
        isFetchingBlocks: { $set: action.value },
      });
    }

    case SET_CURRENT_MONTH: {
      return immutableUpdate(state, {
        currentMonth: { $set: action.value },
      });
    }

    default:
      return state;
  }
}
